import React, {useState} from "react";
import {Alert, Button, FormControl, Input, Paper, Stack, Typography, Link} from "@mui/material";
import {useNavigate, useSearchParams, Link as RouterLink} from "react-router-dom";
import {makeApiCall} from "../hooks/CancellableApiCall";
import useUser from "../hooks/useUser";

export const RecordSearchPage = () => {
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams()
    const [searchTarget, setSearchTarget] = useState(searchParams.get("target") ?? "")
    const [searchReason, setSearchReason] = useState(searchParams.get("reason") ?? "")
    const navigate = useNavigate()
    const user = useUser()

    return <>
        <Stack spacing={2}>
            <Alert variant={"outlined"} severity="error">All record queries are logged by the Professional Standards Department. In order to carry out a record check you need a valid reason, that you have to provide in the query. For more information check <Link underline={"none"} component={RouterLink} to={`https://sites.google.com/view/officers-handbook/9-general-policies/9c-data-protection-and-confidentiality?authuser=0`}>{"Data Protection and Confidentiality"}</Link> policies</Alert>
            <Alert variant={"outlined"} severity="info">Identifier works for badge numbers, usernames, or communityIds</Alert>
        </Stack>
        <Typography sx={{pt:5}} variant="h6" gutterBottom>Record Access</Typography>
        <Paper variant={"outlined"} sx={{p: {xs: 2, sm: "20px"}}}>
            <Stack spacing={1}>
                <FormControl>
                    <Input id="id" sx={{width: "100%", pt:2}} value={searchTarget} placeholder="Identifer..."
                           onChange={(event) => setSearchTarget(event.target.value)}/>
                </FormControl>
                <FormControl sx={{pt:3}}>
                    <Input id="reason" multiline rows={2} value={searchReason} placeholder="Reason for search..."
                           onChange={(event) => setSearchReason(event.target.value)}/>
                </FormControl>
            </Stack>
            <Button sx={{mt:2, width:"100%"}} variant={"contained"} color="error" disabled={searchReason === "" || searchTarget === ""} onClick={() => {
                makeApiCall({
                    url: `/api/records/search/${searchTarget}`,
                    method: "POST",
                    body: {
                        reason: searchReason,
                        target: searchTarget
                    },
                    onLoadedCallback: (data: {sessionId: string}) => {
                        navigate(`/records/${searchTarget}?session=${data.sessionId}`)
                    },
                    onError: () => {
                        navigate(`/records/${searchTarget}`)
                    }
                })
            }}>Search</Button>
        {user.hasPermissions("records:viewRecordLogs") &&
        <Button sx={{mt:2, width:"100%"}} variant="outlined" component={RouterLink} to="/record/logs" color="info">Record Logs</Button> }
        </Paper>
    </>
}